import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { HomeElement } from 'src/app/models/HomepageElement';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
declare const $: any;

@Component({
  selector: 'app-homepage-management',
  templateUrl: './homepage-management.component.html',
  styleUrls: ['./homepage-management.component.css']
})
export class HomepageManagementComponent implements OnInit {
  home: HomeElement[];
  section: string;
  homeIds: number[];
  selectedId: number;
  isDisabled = true;

  constructor(private service: ApiService) { }

  ngOnInit() {
    this.getHomeList();
  }
  async getHomeList() {
    
    $(".loader").addClass("flex-center");
    this.home = await this.service.getHomepageList(false);

    // Recupero gli id dei clienti per ciclarli
    this.homeIds = this.home.map(a => a.idHome);

    // Faccio un disctinct degli id per ciclare senza duplicati
    this.homeIds = this.homeIds.filter((thing, i, arr) => arr.findIndex(t => t === thing) === i);

    $(".loader").removeClass("flex-center");
  }

  getFlag(lang?: string) {
    return "./assets/img/" + lang + "_flag.svg"
  }
  getHomeById(id: number) {
    return this.home.filter(a => a.idHome == id);
  }

  showModalEdit(id: number) {
    this.selectedId = id;
    $('.modal-item').modal('show');
  }
  async update() {
    await this.service.updateHomepageList(this.selectedId, this.getHomeById(this.selectedId));
    this.getHomeList();
  }
  showModalDelete(id: number) {
    this.selectedId = id;
    $('.delete-item').modal('show');
  }
  async deleteHome() {
    await this.service.deleteHomepageList(this.selectedId);
    this.getHomeList();
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    console.log('lista', this.homeIds)
  }
  saveOrdering() {
    this.isDisabled = true;
  }
}
